import * as React from 'react';

import { Text, TextLink } from '@lightspeed/flame/Text';

import { Button } from '@lightspeed/flame/Button';
import { Divider } from '@lightspeed/flame/Divider';
import { ModalFooter as FlameModalFooter } from '@lightspeed/flame/Modal';
import { Flex } from '@lightspeed/flame/Core';
import { IconInfo } from '@lightspeed/flame/Icon/Info';
import { getStore } from 'pages/store/selectors/employeeShops';
import styled from '@emotion/styled';
import { theme } from '@lightspeed/flame/Core/themes/flame';
import { useSelector } from 'react-redux';

const StyledTextLink = styled(TextLink)`
  text-decoration: underline;
  margin-left: 3px; // fixes translations that trim empty spaces
`;

const StyledFooter = styled(FlameModalFooter)`
  background-color: ${theme.colors.white};
  padding: ${theme.space[0]};
`;

interface Props {
  onCancelClick: () => void;
  onSaveClick: () => void;
}

const ModalFooter: React.FC<Props> = ({ onCancelClick, onSaveClick }) => {
  const { shops } = useSelector(getStore);
  const employeeShops = shops.filter(shop => shop.hasAccess);
  const canSave = !!employeeShops.length;

  const handleLinkOnClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    if (window.isGriffin()) {
      window.navigateToContent('listing', 'admin.listings.employee_roles');
      return;
    }
    window.open('/?name=admin.listings.employee_roles&form_name=listing', '_blank');
  };

  return (
    <StyledFooter>
      <Flex justifyContent="center" alignItems="center" px={1} py={2}>
        <IconInfo
          color={theme.colors['gray-600']}
          css={{ marginRight: theme.space[1] }}
          size="14px"
        />
        <Text size="small" color={theme.colors['gray-600']}>
          To restrict access to quantity-on-hand levels by location, go to
        </Text>
        <StyledTextLink
          color={theme.colors['gray-600']}
          data-testid="link-to-employee-roles"
          size="small"
          onClick={handleLinkOnClick}
        >
          Roles
        </StyledTextLink>
      </Flex>
      <Divider />
      <Flex justifyContent="flex-end" py={2} px={3}>
        <Button
          data-testid="cancel-btn"
          fill
          onClick={onCancelClick}
          style={{ marginRight: theme.space[2] }}
        >
          Cancel
        </Button>
        <Button
          data-testid="save-btn"
          disabled={!canSave}
          fill
          onClick={onSaveClick}
          variant="secondary"
        >
          Save
        </Button>
      </Flex>
    </StyledFooter>
  );
};

export default ModalFooter;
